import { QueryKey } from '@fabric-ui/utils';
import { gql } from 'graphql-request';
import { useGqlQuery } from '../../API/useAvQuery';

const GET_PERMITTED_DASHBOARD_REPORTS_FOR_USER = gql`
  query getPermittedDashboardReportsForUser($ids: [String!]!) {
    getPermittedDashboardReportsForUser(ids: $ids) {
      allowed
      allowedIds
      notAllowedIds
    }
  }
`;

export interface ReportPermissionValidationResult {
  allowed: boolean;
  allowedIds: string[];
  notAllowedIds: string[];
}

export const useReportPermissions = (ids: string[]) => {
  const { data, ...rest } = useGqlQuery<{ getPermittedDashboardReportsForUser: ReportPermissionValidationResult }, { ids: string[] }>({
    queryKey: [QueryKey.ReportPermissions, ids],
    query: GET_PERMITTED_DASHBOARD_REPORTS_FOR_USER,
    variables: { ids },
    enabled: !!ids.length,
  });

  return { allowed: false, allowedIds: [] as string[], notAllowedIds: [] as string[], ...data, ...rest };
};
